import { Box, CircularProgress } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../Redux/hooks";
import { setAuthHydrated, setUserAuth } from "../../Redux/reducers/userSlice";
import { clearExistingAuthSession } from "../../utils/clearAuthSession";
import { fetchSession } from "../../utils/fetchSession";

type Props = {
  children: ReactNode;
};

const SessionBootstrap = ({ children }: Props) => {
  const dispatch = useAppDispatch();
  const authHydrated = useAppSelector((state) => state.user.authHydrated);
  const [bootstrapping, setBootstrapping] = useState(
    () => !!localStorage.getItem("sm-access-token") && !authHydrated
  );

  useEffect(() => {
    const bootstrap = async () => {
      const token = localStorage.getItem("sm-access-token");

      if (!token) {
        dispatch(setAuthHydrated(true));
        setBootstrapping(false);
        return;
      }

      if (authHydrated) {
        setBootstrapping(false);
        return;
      }

      setBootstrapping(true);
      const session = await fetchSession();

      if (session?.id && session?.role) {
        dispatch(
          setUserAuth({
            authenticated: true,
            role: session.role,
            userId: session.id,
          })
        );
        dispatch(setAuthHydrated(true));
        setBootstrapping(false);
        return;
      }

      await clearExistingAuthSession(dispatch);
      dispatch(setAuthHydrated(true));
      setBootstrapping(false);
    };

    bootstrap();
  }, [authHydrated, dispatch]);

  if (bootstrapping) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    );
  }

  return <>{children}</>;
};

export default SessionBootstrap;
